<template>
  <div>
    <!-- Head -->
    <div class="m-2">
      <b-row align-h="between">
        <!-- Search -->
        <b-col
          cols="12"
          md="4"
          class="mb-1 mb-md-0"
        >
          <div
            v-if="search"
            class="d-flex align-items-center"
          >
            <form
              class="w-100"
              @submit.prevent="handleSearch"
            >
              <b-input-group class="input-group-merge">
                <b-input-group-prepend is-text>
                  <feather-icon icon="SearchIcon" />
                </b-input-group-prepend>
                <b-form-input
                  v-model="searchKeyword"
                  :placeholder="searchPlaceholder"
                />
              </b-input-group>
            </form>
          </div>
        </b-col>
        <!-- Actions -->
        <b-col
          v-if="actions.length"
          cols="12"
          md="6"
        >
          <b-row
            class="action-content"
            align-h="end"
            align-v="center"
          >
            <b-col
              v-for="(item, index) in actions"
              :key="`list-action-${index}`"
              cols="12"
              :md="item.includes('button') ? 'auto' : 6"
            >
              <slot :name="item" />
            </b-col>
          </b-row>
        </b-col>

        <b-col
          v-else
          cols="12"
          md="auto"
        >
          <slot name="action" />
        </b-col>
      </b-row>
    </div>

    <!-- Alert -->
    <div
      v-if="search && keyword"
      class="mx-2"
    >
      <b-alert
        variant="primary"
        show
        class="d-flex align-items-center"
      >
        <feather-icon
          icon="XIcon"
          class="mr-50 pointer"
          @click="handleReset"
        />
        <div>Menampilkan hasil untuk "{{ keyword }}"</div>
      </b-alert>
    </div>
  </div>
</template>

<script>
import {
  BAlert,
  BCol,
  BFormInput,
  BInputGroup,
  BInputGroupPrepend,
  BRow,
} from 'bootstrap-vue'

export default {
  components: {
    BAlert,
    BCol,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BRow,
  },
  props: {
    search: {
      type: Boolean,
      default: false,
    },
    searchPlaceholder: {
      type: String,
      default: 'Cari data',
    },
    payload: {
      type: Object,
      default: () => ({}),
    },
    searchAction: {
      type: String,
      default: '',
    },
    actions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      searchKeyword: '',
    }
  },
  computed: {
    keyword() {
      return this.$route.query.keyword
    },
  },
  watch: {
    keyword(value) {
      this.searchKeyword = value || ''
    },
  },
  created() {
    if (this.search) this.searchKeyword = this.keyword
  },
  methods: {
    handleSearch() {
      this.$router.push({ query: { ...this.$route.query, keyword: this.searchKeyword, page: 1 } })
      this.$store.dispatch(this.searchAction, {
        ...this.payload,
        ...this.$route.query,
        keyword: this.searchKeyword,
        page: 1,
      })
      this.$emit('search', this.searchKeyword)
    },
    async handleReset() {
      this.searchKeyword = ''
      const queryLocal = await this.onGetLastQueryLocal()
      await this.$router.push({ query: { ...this.$route.query, keyword: undefined, page: 1 } })

      if (queryLocal) {
        await this.onSaveLastQueryLocal()
      }

      this.$store.dispatch(this.searchAction, {
        ...this.payload,
        ...this.$route.query,
        keyword: undefined,
        page: 1,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@media (min-width: 992px) {
  .header-content {
    justify-content: space-between;
  }
 }

 .pointer {
  cursor: pointer;
 }
</style>
